import React from 'react';
import BomMaterialGroup from './BomMaterialGroup'
import withView from '../../../cmn/docAutomation/withView';
import { UiGridColOne, UiGridColTwo, UiGridColThree, UiCol } from "../../../../library/layout/Index";

const groupCountView = {
    "0": UiGridColOne,
    "1": UiGridColOne, 
    "2": UiGridColTwo, 
    "3": UiGridColThree
}

const BomMaterial = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    const groupData = formObject.getFormRow('', 'lineItemLink');

    const GridColumns = groupCountView[(groupData && groupData.RowValuesKeys.length) || 0] || groupCountView["0"];

    return (
        <GridColumns>
            {
                Object.values(groupData.rowValues).map((group, index) => (
                    <UiCol key={index}>
                        <BomMaterialGroup formObject={formObject} viewData={viewData} groupData={group} groupKey={group.key} />
                    </UiCol>
                ))
            }
        </GridColumns>
    )
}

export default withView(BomMaterial, "bomItem", "bomHeader");